import { PillTheme } from "../pill-theme";

export enum CustomerTagSource {
  REDO_SUPPORT = "redo-support",
  SHOPIFY = "shopify",
  REDO_MARKETING = "redo-marketing",
}

export interface CustomerTagRecord {
  _id: string;
  teamId: string;
  name: string;
  pillTheme: PillTheme;
  source: CustomerTagSource;
}
